import React from "react";
import { useContent } from '../contexts/ContentContext';
import '../assets/styles/Certifications.scss';

function Certifications() {
  const { content } = useContent();
  const certifications = content.certifications;

  return (
    <div className="certifications-container" id="certifications">
      <div className="items-container">
        <div className="section-code-header">
          <span className="code-keyword">export</span>
          <span className="code-keyword">const</span>
          <span className="code-variable">certifications</span>
          <span className="code-operator">=</span>
          <span className="code-bracket">[</span>
        </div>
        <p className="section-comment">// Verified certifications and credentials for deep technical leadership</p>
        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <div key={index} className="certification-card">
              <div className="certification-header">
                <h3 className="certification-title">{cert.title}</h3>
                <span className="certification-issuer">{cert.issuer}</span>
              </div>
              <span className="certification-date">{cert.date}</span>
              <div className="certification-link-wrapper">
                <a href={cert.credential} target="_blank" rel="noopener noreferrer" className="certification-link">
                  <span className="code-tag">View Credential</span>
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="section-code-footer">];</div>
      </div>
    </div>
  );
}

export default Certifications;